module.exports = __webpack_public_path__ + "img/logo15.ab2b14d4.png";